import React, { useEffect, useRef, useState } from "react";
import { AlertTriangle, Edit, Plus, User } from "react-feather";
import { CgTemplate } from "react-icons/cg";
import { HiTemplate } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Card, CardContent, Icon, Label } from "semantic-ui-react";
import { getBulkDropdownData, getDropdownData } from "../../../api/keyvalue";
import {
  getCommonDropdownValues,
  getDynamicReportTypes,
  getDynamicTemplateById,
  saveDynamicTemplate,
  updateDynamicTemplate,
} from "../../../api/templateApi";
import { AUTH_TYPES, FORMS, MODULES } from "../../../const";
import { isNumber } from "../../../helper";
import useFirstAndLastAuthorizedTab from "../../../hooks/useFirstAndLastAuthorizedTab";
import useNextAndPreviousAuthority from "../../../hooks/useNextAndPreviousAuthority";
import useUserCompany from "../../../hooks/useUserCompany";
import { templateActions } from "../../../store/master/template-slice";
import Grid from "../../Grid";
import LoadingSpinner from "../../LoadingSpinner";
import Modal from "../../Modal";
import Tab from "../../Tab";
import Button from "../../input/Button";
import CheckBox from "../../input/CheckBox";
import Dropdown from "../../input/Dropdown";
import Input from "../../input/Input";
import ButtonRenderer from "../../renderer/ButtonRenderer";
import SelectRenderer from "../../renderer/SelectRenderer";
import {
  AsyncDropdownValueRenderer,
  ResizableScrollingTextRenderer,
} from "../../renderer/StyleRenderer";
import {
  dynamicFieldCreationValidation,
  dynamicTemplateCreationValidation,
} from "../../validations/DynamicTemplateHeader";
import TemplateDropdown from "./TemplateDropdown";
import AlertForm from "../../alert/AlertForm";
import InfoList from "../../InfoList";
import { formatFromJsonDate } from "../../../dateConfig";

const DynamicTemplateCreation = ({
  editMode,
  setEditMode,
  selectedId,
  handleDrawerClose,
  selectedCode,
  reset,
  setReset,
  addMode,
  setAddMode,
  setUpdateNeeded,
}) => {
  const { firstViableTab, lastViableTab } = useFirstAndLastAuthorizedTab({
    module: MODULES.Fleet,
    section: FORMS.TEMPLATE,
  });
  const [tab, setTab] = useState(firstViableTab);
  const fieldCount = useSelector((state) => state.template.fieldCount);

  const user = useSelector((state) => state.user);
  const fieldList = useSelector((state) => state.template.fieldList);
  const dispatch = useDispatch();
  const [proceedReset, setProceedReset] = useState(false);
  const [delitedFieldList, setDeletedFieldList] = useState([]);
  console.log("fieldList: ", fieldList);

  const [buttonClicked, setButtonClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fieldAddLoading, setFieldAddLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const gridFieldRef = useRef(null);
  const [currentErrors, setCurrentErrors] = useState({});

  const alertRef = useRef();

  const { next, prev } = useNextAndPreviousAuthority({
    sectionKey: "dynamicTemplate112",
    minTab: 1,
    maxTab: 3,
    module: MODULES.Fleet,
    section: FORMS.TEMPLATE,
    currentTab: tab,
    authenticated: true,
  });
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [dynamicReportTypeOptions, setDynamicReportTypeOptions] = useState([]);
  const [managementTypeOptions, setManagementTypeOptions] = useState([]);
  const [uomOptions, setUomOptions] = useState([]);
  const [fieldTypeOptions, setFieldTypeOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [activeOptions, setActiveOptions] = useState([]);
  const [yesNoOptions, setYesNoOptions] = useState([]);
  const [commonDropdownOptions, setCommonDropdownOptions] = useState([]);
  const [commonDropdownId, setCommonDropdownId] = useState(0);
  const [altActiveOpt, setAltActiveOpt] = useState([]);
  const [altStatusOpt, setAltStatusOpt] = useState([]);
  const [altTypeOpt, setAltTypeOpt] = useState([]);
  const [altEventOpt, setAltEventOpt] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [altDefaultTypeOpt, setAltDefaultTypeOpt] = useState([]);

  const [dyhTemplate, setDyhTemplate] = useState("");
  const [dyhNextInspection, setDyhNextInspection] = useState("");
  const [dyhNextKm, setDyhNextKm] = useState("");
  const [dyhNextUom, setDyhNextUom] = useState("");
  const [dyhDescription, setDyhDescription] = useState("");
  const [dyhCategory, setDyhCategory] = useState("");
  const [dyhInspectionType, setDyhInspectionType] = useState("");
  const [dyhStatus, setDyhStatus] = useState(2);
  const [dyhActive, setDyhActive] = useState(1);
  const [dyhReportType, setDyhReportType] = useState(2);
  const [
    dyhMultiSelectDynamicColumnOptions,
    setDyhMultiSelectDynamicColumnOptions,
  ] = useState([]);
  const [isDynamicDropdownValuesLoading, setIsDynamicDropdownValuesLoading] =
    useState(false);
  const [dyhAlert, setDyhAlert] = useState("");

  const [addModeInModal, setAddModeInModal] = useState(true);
  const [flag, setFlag] = useState(false);
  const [isEditModeDataLoading, setIsEditModeDataLoading] = useState(false);
  const [isBlurred, setIsBlurred] = useState(false);
  const modalRef = useRef();
  const [fieldSeq, setFieldSeq] = useState(0);
  const userCompany = useUserCompany();
  const [auditInfo, setAuditInfo] = useState({});
  const [commonDropdownInput, setCommonDropdownInput] = useState({});
  const [company, setCompany] = useState(
    userCompany ? userCompany.comId : null,
  );
  useEffect(() => {
    setCompany(userCompany ? userCompany.comId : null);
  }, [userCompany]);

  const closeModal = () => {
    setFlag(false);
    setAddModeInModal(true);
    modalRef.current.close();
  };

  const openModal = () => {
    modalRef.current?.showModal();
  };

  const [fieldData, setFieldData] = useState({
    dyfReferance: "",
    dyfCompany: 1,
    dyfDynamic: null,
    dyfField: "",
    dyfFieldType: "",
    dyfUom: null,
    dfyCommonDropdown: null,
    dfyCommonDropdownValue: null,
    dyfMultiSelectDynamicColumn: [],
    dfyCommonTable: null,
    dyfDefaultValue: "",
    dyfDescription: "",
    dyfRequired: false,
    dyfSeq: 1,
    dyfStatus: 2,
    dyfActive: 1,
    dfyAmount: 2,
    dfyDiscount: 2,
    dyfCalculated: false,
    dyfComment: "",
    dyfSatisfyLevel: false,
    dyfFieldStatus: false,
    dyfTdfDescription: false,
    componentTypeValue: "",
    dropdownValues: [],
    dropdownCount: 1,
    currentDropdownSeq: 1,
    dropdownDefaultValueName: "",
    author: user.username,
  });

  console.log("fieldData", fieldData);

  const [dropdownValue, setDropdownValue] = useState({
    id: null,
    dydId: null,
    dydReferance: "",
    dydCompany: 1,
    dydDyfId: null,
    dydValue: "",
    dydUom: null,
    dydDescription: "",
    dydRequired: false,
    dydSeq: 1,
    dydStatus: 2,
    dydActive: 1,
    default: false,
    author: user.username,
  });

  useEffect(() => {
    if (reset) {
      resetForm();
      setReset(false);
    }
  }, [reset]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      // new
      const {
        active,
        status,
        inspection_category: categoryOpt,
        inspection_type: managementTypeOpt,
        "uom#time2": uomOpt,
        "component_type#fields": fieldTypeOpt,
        yesno: yesNoOpt,
        evn_type: altEventData,
        alert_type: altTypeData,
        default_select_types: altDefaultTypes,
      } = await getBulkDropdownData([
        { key: "inspection_category" },
        { key: "inspection_type" },
        { key: "uom", group: "time2" },
        { key: "component_type", group: "fields" },
        { key: "status" },
        { key: "active" },
        { key: "yesno" },
        { key: "evn_type" },
        { key: "alert_type" },
        { key: "default_select_types" },
      ]);
      setStatusOptions(status);
      setActiveOptions(active);

      setCategoryOptions(categoryOpt);
      setManagementTypeOptions(managementTypeOpt);
      console.log("uom options", uomOpt);
      setUomOptions(uomOpt);
      console.log("fieldTypeOpt", fieldTypeOpt);
      setFieldTypeOptions(fieldTypeOpt);
      setYesNoOptions(yesNoOpt);
      setAltEventOpt(altEventData);
      setAltTypeOpt(altTypeData);
      setAltStatusOpt(status);
      setAltActiveOpt(active);
      setAltDefaultTypeOpt(altDefaultTypes);

      const reportTypesList = await getDynamicReportTypes();
      setDynamicReportTypeOptions(reportTypesList || []);

      setIsLoading(false);
    })();
  }, []);

  console.log("Alt default type options", altDefaultTypeOpt);

  useEffect(() => {
    (async () => {
      let fetchType = "any"; // Default fetch type

      if (
        (fieldData.dyfFieldType === 8 && fieldData.dfyCommonDropdown === 19) ||
        fieldData.dfyCommonDropdown === 22
      ) {
        fetchType = "item"; // Fetch under "item" only when common dropdown === 19
      }

      const dynamicColumn = await getDropdownData("dynamic_columns", fetchType);
      setDyhMultiSelectDynamicColumnOptions(dynamicColumn);

      // ✅ Ensure correct format for a new entry (NOT in edit mode)
      if (!editMode && editIndex === null) {
        setFieldData((prevData) => ({
          ...prevData,
          dyfMultiSelectDynamicColumn: dynamicColumn.reduce((acc, option) => {
            acc[option.value] = option.text; // ✅ Store `{ key: name }`
            return acc;
          }, {}),
        }));
      } else {
        // ✅ Ensure existing selected columns are in correct format for edit mode
        let existingSelection = fieldData.dyfMultiSelectDynamicColumn;

        if (!existingSelection || typeof existingSelection !== "object") {
          existingSelection = {};
        }

        setFieldData((prevData) => ({
          ...prevData,
          dyfMultiSelectDynamicColumn: existingSelection,
        }));
      }
    })();
  }, [fieldData.dyfFieldType, fieldData.dfyCommonDropdown, editIndex]);

  useEffect(() => {
    (async () => {
      setIsDynamicDropdownValuesLoading(true);
      if (fieldData.dyfFieldType === 8) {
        const commonDropdownOpt = await getCommonDropdownValues();
        setCommonDropdownOptions(commonDropdownOpt);
      } else {
        setFieldData({
          ...fieldData,
          dfyCommonDropdown: null,
          dfyCommonDropdownValue: null,
          dfyCommonTable: null,
        });
        setCommonDropdownInput({});
      }

      setIsDynamicDropdownValuesLoading(false);
    })();
  }, [fieldData.dyfFieldType]);

  useEffect(() => {
    if (!fieldData.dyfFieldType || fieldData.dyfFieldType === "") {
      setFieldData({
        ...fieldData,
        dyfDefaultValue: "",
      });
    }
  }, [fieldData.dyfFieldType]);

  console.log("field data", fieldData);

  const resetForm = () => {
    setDyhTemplate("");
    setDyhNextInspection("");
    setDyhNextUom("");
    setDyhDescription("");
    setDyhCategory("");
    setDyhInspectionType("");
    setDyhActive(1);
    setDyhStatus(2);

    dispatch(templateActions.clearFieldList());
    setFieldSeq(0);
    setDeletedFieldList([]);
    setCommonDropdownInput({});
    setFieldData({
      dyfReferance: "",
      dyfCompany: 1,
      dyfDynamic: null,
      dyfField: "",
      dyfFieldType: "",
      dyfUom: null,
      dfyCommonDropdown: null,
      dfyCommonDropdownValue: null,
      dyfMultiSelectDynamicColumn: [],
      dfyCommonTable: null,
      dyfDefaultValue: "",
      dyfDescription: "",
      dyfRequired: false,
      dyfSeq: 1,
      dyfStatus: 2,
      dyfActive: 1,
      dyfCalculated: false,
      dyfComment: "",
      dyfSatisfyLevel: false,
      dyfFieldStatus: false,
      dyfTdfDescription: false,
      dropdownValues: [],
      dropdownCount: 1,
      currentDropdownSeq: 1,
      dropdownDefaultValueName: "",
    });
  };

  useEffect(() => {
    (async () => {
      if (editMode) {
        setIsEditModeDataLoading(true);
        const dataRow = await getDynamicTemplateById(selectedId);
        console.log("dataRow", dataRow);

        setDyhTemplate(dataRow.dyhTemplate);
        setDyhNextInspection(dataRow.dyhNextInspection);
        setDyhNextUom(dataRow.dyhNextUom);
        setDyhNextKm(dataRow.dyhNextKm);
        setDyhDescription(dataRow.dyhDescription);
        setDyhCategory(dataRow.dyhCategory);
        setDyhInspectionType(dataRow.dyhInspectionType);
        setDyhActive(dataRow.dyhActive);
        setDyhStatus(dataRow.dyhStatus);
        setDyhReportType(dataRow.dyhReportType);
        setDyhAlert(dataRow);
        setAuditInfo({
          createdDate: dataRow.createdDate,
          createdBy: dataRow.createdBy,
          lastModifiedBy: dataRow.lastModifiedBy,
          lastModifiedDate: dataRow.lastModifiedDate,
        });

        dispatch(templateActions.clearFieldList());

        dataRow.dynamicFields?.forEach((field) => {
          console.log("the dynamic fields: ", field.dynamicColumns);

          // Ensure dyfMultiSelectDynamicColumn is mapped correctly
          const mappedColumns = field.dynamicColumns.reduce((acc, col) => {
            acc[col.ddcField] = col.ddcFieldText; // Storing { ddcField: ddcFieldText }
            return acc;
          }, {});

          dispatch(
            templateActions.addToFieldList({
              ...field,
              dyfReferance: field.dyfReferance,
              dfyCommonDropdownValue: field.dfyCommonDropdownValue,
              dyfSeq: field.dyfSeq,
              dyfRequired: field.dyfRequired === 1 ? true : false,
              dyfCalculated: field.dyfCalculated === 1 ? true : false,
              dyfMultiSelectDynamicColumn: mappedColumns, // ✅ Correct format
              currentDropdownSeq: field.dynamicDropdowns
                ? field.dynamicDropdowns.length + 1
                : 0,
              dropdownDefaultValueName:
                field.dyfFieldType === 4 && field.dynamicDropdowns.length > 0
                  ? field.dynamicDropdowns.find(
                      (dropdown) =>
                        dropdown.dydSeq === parseInt(field.dyfDefaultValue),
                    )?.dydValue || ""
                  : "",
              dyfDefaultValue:
                field.dyfFieldType === 6
                  ? field.dyfDefaultValue === "true"
                    ? true
                    : false
                  : field.dyfDefaultValue,
              dropdownValues: field.dynamicDropdowns?.map(
                (dropdown, index) => ({
                  ...dropdown,
                  id: index + 1,
                  dydRequired: dropdown.dydRequired === 1 ? true : false,
                  default: dropdown.dydSeq === parseInt(field.dyfDefaultValue),
                }),
              ),
            }),
          );
        });

        setFieldSeq(dataRow.dynamicFields.length);
        setIsEditModeDataLoading(false);
      }
    })();
  }, [editMode, selectedId, dispatch]);

  useEffect(() => {
    if ((buttonClicked && fieldData.dyfFieldType !== 4) || proceedReset) {
      setFieldData({
        dyfReferance: "",
        dyfCompany: 1,
        dyfDynamic: null,
        dyfField: "",
        dyfFieldType: "",
        dyfUom: null,
        dfyCommonDropdown: null,
        dfyCommonDropdownValue: null,
        dfyCommonTable: null,
        dyfMultiSelectDynamicColumn: [],
        dyfDefaultValue: "",
        dyfDescription: "",
        dyfRequired: false,
        dyfSeq: 1,
        dyfStatus: 2,
        dyfActive: 1,
        dfyAmount: 2,
        dfyDiscount: 2,
        dyfCalculated: false,
        dyfComment: "",
        dyfSatisfyLevel: false,
        dyfFieldStatus: false,
        dyfTdfDescription: false,
        dropdownValues: [],
        dropdownCount: 1,
        currentDropdownSeq: 1,
        dropdownDefaultValueName: "",
        author: user.username,
      });
      setCommonDropdownInput({});
      setButtonClicked(false);
      setProceedReset(false);
    }
  }, [
    buttonClicked,
    dyhTemplate,
    user.username,
    fieldData.dyfFieldType,
    proceedReset,
  ]);

  const onFieldAddClick = () => {
    setFieldAddLoading(true);
    console.log("the dynamic field data: ", fieldData);
    // Only check for existing item if adding a new field (not updating an existing one)
    if (
      fieldData.dyfFieldType === 8 &&
      fieldData.dfyCommonDropdown === 19 &&
      !fieldData.id &&
      !fieldData.dyfId
    ) {
      const existingItemField = fieldList.find(
        (field) => field.dyfFieldType === 8 && field.dfyCommonDropdown === 19,
      );

      if (existingItemField) {
        toast.error("Only one Item can be added for this Common Dropdown.", {
          autoClose: 5000,
          containerId: "Main",
        });
        setFieldAddLoading(false);
        return;
      }
    }

    if (
      fieldData.dyfFieldType === 8 &&
      fieldData.dfyCommonDropdown === 22 &&
      !fieldData.id &&
      !fieldData.dyfId
    ) {
      const existingItemField = fieldList.find(
        (field) => field.dyfFieldType === 8 && field.dfyCommonDropdown === 22,
      );

      if (existingItemField) {
        toast.error("Only one Charge can be added for this Common Dropdown.", {
          autoClose: 5000,
          containerId: "Main",
        });
        setFieldAddLoading(false);
        return;
      }
    }

    // 🔥 New check: Block adding Charge if Item exists, and vice versa
    if (
      fieldData.dyfFieldType === 8 &&
      fieldData.dfyCommonDropdown === 19 &&
      !fieldData.id &&
      !fieldData.dyfId
    ) {
      // Existing Item check (already handled)
      const existingChargeField = fieldList.find(
        (field) => field.dyfFieldType === 8 && field.dfyCommonDropdown === 22,
      );

      if (existingChargeField) {
        toast.error("Cannot add Item. A Charge field already exists.", {
          autoClose: 5000,
          containerId: "Main",
        });
        setFieldAddLoading(false);
        return;
      }
    }

    if (
      fieldData.dyfFieldType === 8 &&
      fieldData.dfyCommonDropdown === 22 &&
      !fieldData.id &&
      !fieldData.dyfId
    ) {
      const existingItemField = fieldList.find(
        (field) => field.dyfFieldType === 8 && field.dfyCommonDropdown === 19,
      );

      if (existingItemField) {
        toast.error("Cannot add Charge. An Item field already exists.", {
          autoClose: 5000,
          containerId: "Main",
        });
        setFieldAddLoading(false);
        return;
      }
    }

    if (fieldData.dyfFieldType !== 8) {
      const fieldValidationErrors = dynamicFieldCreationValidation({
        dyfField: fieldData.dyfField,
        dyfFieldType: fieldData.dyfFieldType,
      });

      if (Object.entries(fieldValidationErrors).length > 0) {
        toast.error("Fill the required fields in this section", {
          autoClose: 5000,
          containerId: "Main",
        });
        setCurrentErrors(fieldValidationErrors);
        setFieldAddLoading(false);
        return;
      }
    } else if (fieldData.dyfFieldType === 8) {
      const fieldValidationErrors = dynamicFieldCreationValidation({
        dyfField: fieldData.dyfField,
        dyfFieldType: fieldData.dyfFieldType,
        dfyCommonDropdown: fieldData.dfyCommonDropdown,
      });
      console.log("fieldValidationErrors", fieldValidationErrors);

      if (Object.entries(fieldValidationErrors).length > 0) {
        toast.error("Fill the required fields in this section", {
          autoClose: 5000,
          containerId: "Main",
        });
        setCurrentErrors(fieldValidationErrors);
        setFieldAddLoading(false);
        return;
      }
    }

    setCurrentErrors({});

    if (fieldData.dyfFieldType === 4) {
      openModal();
      setFieldAddLoading(false);
      return;
    }
    const cleanMultiDynamicColumn = {
      ...fieldData.dyfMultiSelectDynamicColumn,
    };
    console.log(
      "DEBUG_MULTI_SELECT: CHECK BEFORE SEND",
      cleanMultiDynamicColumn,
      fieldData.dyfMultiSelectDynamicColumn,
    );

    if (!fieldData.dyfId || fieldData.dyfId === null) {
      if (!fieldData.id || fieldData.id === null) {
        let seqId = fieldSeq + 1;
        dispatch(
          templateActions.addToFieldList({
            ...fieldData,
            id: fieldCount,
            dyfSeq: seqId,
            dyfDefaultValue:
              fieldData.dyfFieldType === 6 && !fieldData.dyfDefaultValue
                ? false
                : fieldData.dyfDefaultValue,
            dyfMultiSelectDynamicColumn: cleanMultiDynamicColumn,
            created: true,
          }),
        );
        setFieldSeq(seqId);
        dispatch(templateActions.incrementFieldCount());
      } else {
        dispatch(
          templateActions.updateFieldList({
            ...fieldData,
            dyfDefaultValue:
              fieldData.dyfFieldType === 6 && !fieldData.dyfDefaultValue
                ? false
                : fieldData.dyfDefaultValue,
            dyfMultiSelectDynamicColumn: cleanMultiDynamicColumn,
            created: true,
          }),
        );
        setEditIndex(null);
      }
    } else {
      dispatch(
        templateActions.updatePersistedFieldList({
          ...fieldData,
          dyfDefaultValue:
            fieldData.dyfFieldType === 6 && !fieldData.dyfDefaultValue
              ? false
              : fieldData.dyfDefaultValue,
          dyfMultiSelectDynamicColumn: cleanMultiDynamicColumn,
          modified: true,
        }),
      );
      setEditIndex(null);
    }

    console.log("Updated Data Payload: the dyfMultiSelct: ", fieldData);
    setDyhMultiSelectDynamicColumnOptions([]);

    setButtonClicked(true);
    setAddMode(true);
    setFieldAddLoading(false);
  };

  const editDropdownFieldWithoutValues = () => {
    setFieldAddLoading(true);

    if (fieldData.dyfFieldType !== 8) {
      const fieldValidationErrors = dynamicFieldCreationValidation({
        dyfField: fieldData.dyfField,
        dyfFieldType: fieldData.dyfFieldType,
      });

      if (Object.entries(fieldValidationErrors).length > 0) {
        toast.error("Fill the required fields in this section", {
          autoClose: 5000,
          containerId: "Main",
        });
        setCurrentErrors(fieldValidationErrors);
        setFieldAddLoading(false);
        return;
      }
    } else if (fieldData.dyfFieldType === 8) {
      const fieldValidationErrors = dynamicFieldCreationValidation({
        dyfField: fieldData.dyfField,
        dyfFieldType: fieldData.dyfFieldType,
        dfyCommonDropdown: fieldData.dfyCommonDropdown,
      });

      console.log("fieldValidationErrors", fieldValidationErrors);

      if (Object.entries(fieldValidationErrors).length > 0) {
        toast.error("Fill the required fields in this section", {
          autoClose: 5000,
          containerId: "Main",
        });
        setCurrentErrors(fieldValidationErrors);
        setFieldAddLoading(false);
        return;
      }
    }

    setCurrentErrors({});

    const cleanMultiDynamicColumn = {
      ...fieldData.dyfMultiSelectDynamicColumn,
    };

    if (!fieldData.dyfId || fieldData.dyfId === null) {
      if (!fieldData.id || fieldData.id === null) {
        dispatch(
          templateActions.addToFieldList({
            ...fieldData,
            dyfMultiSelectDynamicColumn: cleanMultiDynamicColumn,
            created: true,
          }),
        );
      } else {
        dispatch(
          templateActions.updateFieldList({
            ...fieldData,
            dyfMultiSelectDynamicColumn: cleanMultiDynamicColumn,
            created: true,
          }),
        );
      }
    } else {
      dispatch(
        templateActions.updatePersistedFieldList({
          ...fieldData,
          modified: true,
          dyfMultiSelectDynamicColumn: cleanMultiDynamicColumn,
        }),
      );
    }

    setAddMode(true);
    setFieldAddLoading(false);
    setCommonDropdownInput({});
    setFieldData({
      dyfReferance: "",
      dyfCompany: 1,
      dyfDynamic: null,
      dyfField: "",
      dyfFieldType: "",
      dyfUom: null,
      dfyCommonDropdown: null,
      dfyCommonDropdownValue: null,
      dfyCommonTable: null,
      dyfDefaultValue: "",
      dyfDescription: "",
      dyfRequired: false,
      dyfSeq: 1,
      dyfStatus: 2,
      dyfActive: 1,
      dfyAmount: 2,
      dyfMultiSelectDynamicColumn: [],
      dfyDiscount: 2,
      dyfCalculated: false,
      dyfComment: "",
      dyfSatisfyLevel: false,
      dyfFieldStatus: false,
      dyfTdfDescription: false,
      dropdownValues: [],
      dropdownCount: 1,
      currentDropdownSeq: 1,
      dropdownDefaultValueName: "",
      author: user.username,
    });
  };

  const nextButtonHandler = () => {
    if (tab === 1) {
      const templateCreationErrors = dynamicTemplateCreationValidation({
        // dyhReferance: null,
        // dyhCompany: 1,
        dyhCategory: dyhCategory,
        dyhInspectionType: dyhInspectionType,
        dyhTemplate: dyhTemplate,
        // dyhDescription: dyhDescription,
        dyhNextInspection: dyhNextInspection,
        dyhNextUom: dyhNextUom,
        dyhStatus: dyhStatus,
        dyhActive: dyhActive,
        dyhReportType: dyhReportType,
      });

      console.log("templateCreationErrors", templateCreationErrors);

      if (Object.entries(templateCreationErrors).length > 0) {
        setCurrentErrors(templateCreationErrors);
        toast.error("please fill all the required fields in this section", {
          autoClose: 5000,
          containerId: "Main",
        });
        return;
      } else {
        setCurrentErrors({});
      }
    }
    setTab(next());
  };

  const saveTemplate = async () => {
    setIsSubmitLoading(true);
    setIsBlurred(true);
    setEditMode(false);

    const templateCreationErrors = dynamicTemplateCreationValidation({
      dyhCategory: dyhCategory,
      dyhInspectionType: dyhInspectionType,
      dyhTemplate: dyhTemplate,
      // dyhDescription: dyhDescription,
      dyhNextInspection: dyhNextInspection,
      dyhNextUom: dyhNextUom,
      dyhStatus: dyhStatus,
      dyhActive: dyhActive,
      dyhReportType: dyhReportType,
    });

    if (Object.entries(templateCreationErrors).length > 0) {
      setCurrentErrors(templateCreationErrors);
      toast.error("Please fill all required fields in template details tab..", {
        autoClose: 5000,
        containerId: "Main",
      });
      if (firstViableTab === 1) {
        setTab(1);
      }
      setIsBlurred(false);
      setIsSubmitLoading(false);
      return;
    } else {
      setCurrentErrors({});
    }

    //check whether filedList is empty or not. if empty then return
    if (fieldList?.length === 0) {
      toast.error("Please add at least one field in template fields tab..", {
        autoClose: 5000,
        containerId: "Main",
      });
      setTab(2);
      setIsBlurred(false);
      setIsSubmitLoading(false);
      return;
    }

    const data = {
      dyhReferance: null,
      dyhCompany: company,
      dyhCategory: dyhCategory,
      dyhInspectionType: dyhInspectionType,
      dyhTemplate: dyhTemplate,
      dyhDescription: dyhDescription,
      dyhNextInspection: dyhNextInspection,
      dyhNextUom: dyhNextUom,
      dyhNextKm: dyhNextKm,
      dyhStatus: dyhStatus,
      dyhActive: dyhActive,
      dyhReportType: dyhReportType,
      dynamicFieldRequests: fieldList?.map((field, index) => ({
        dyfReferance: field.dyfReferance,
        dyfCompany: company,
        dyfDynamic: null,
        dyfField: field.dyfField,
        dyfFieldType: field.dyfFieldType,
        dyfUom: null,
        dfyCommonDropdown: field.dfyCommonDropdown,
        dfyCommonTable: null,
        // send the column map
        dynamicColumnRequests:
          Object.keys(field.dyfMultiSelectDynamicColumn || {}).map(
            (key, index) => ({
              ddcReference: "", // Always empty
              ddcCompany: 1, // Always 1
              ddcDyfId: null, // Will be assigned when backend saves it
              ddcField: parseFloat(key), // Use the key as the field value
              ddcSeq: index + 1, // Assign a sequence number correctly
              ddcStatus: 2, // Always 2
              ddcActive: 1, // Always 1
              author: user.username,
            }),
          ) || [],
        dyfDefaultValue: field.dyfDefaultValue,
        dyfDescription: field.dyfDescription,
        dyfRequired: field.dyfRequired ? 1 : 0,
        dyfSeq: field.dyfSeq,
        dyfStatus: 2,
        dyfActive: 1,
        dfyAmount: field.dfyAmount,
        dfyDiscount: field.dfyDiscount,
        dyfCalculated: field.dyfCalculated ? 1 : 0,
        dyfComment: field.dyfComment,
        dyfSatisfyLevel: field.dyfSatisfyLevel,
        dyfFieldStatus: field.dyfFieldStatus,
        dyfTdfDescription: field.dyfTdfDescription,
        dynamicDropdownRequests: field.dropdownValues?.map((dropdown) => ({
          dydReferance: dropdown.dydReferance,
          dydCompany: company,
          dydDyfId: null,
          dydValue: dropdown.dydValue,
          dydUom: null,
          dydDescription: dropdown.dydDescription,
          dydRequired: 1,
          dydSeq: dropdown.dydSeq,
          dydStatus: 2,
          dydActive: 1,
        })),
      })),
      alert: alertRef.current.getData(),
      author: user.username,
    };

    console.log("the log before save: ", data);

    // console.log("the payload",data);
    const response = await saveDynamicTemplate(data);
    console.log("response", response);

    if (response.status === 200) {
      toast.success(
        response.data.dyhCode + " template and details saved successfully!",
        { autoClose: 5000, containerId: "Main" },
      );

      resetForm();
      handleDrawerClose();
      setUpdateNeeded(true);
    } else {
      toast.error("Failed to save the template", {
        autoClose: 5000,
        containerId: "Main",
      });
    }

    setIsSubmitLoading(false);
    setIsBlurred(false);
  };

  const updateTemplate = async () => {
    setIsSubmitLoading(true);
    setIsBlurred(true);

    const templateCreationErrors = dynamicTemplateCreationValidation({
      dyhCategory: dyhCategory,
      dyhInspectionType: dyhInspectionType,
      dyhTemplate: dyhTemplate,
      // dyhDescription: dyhDescription,
      dyhNextInspection: dyhNextInspection,
      dyhNextUom: dyhNextUom,
      dyhStatus: dyhStatus,
      dyhActive: dyhActive,
      dyhReportType: dyhReportType,
    });

    if (Object.entries(templateCreationErrors).length > 0) {
      setCurrentErrors(templateCreationErrors);
      toast.error("Please fill all required fields in template details tab..", {
        autoClose: 5000,
        containerId: "Main",
      });
      if (firstViableTab === 1) {
        setTab(1);
      }
      setIsBlurred(false);
      setIsSubmitLoading(false);
      return;
    } else {
      setCurrentErrors({});
    }

    //check whether filedList is empty or not. if empty then return
    if (fieldList?.length === 0) {
      toast.error("Please add at least one field in template fields tab..", {
        autoClose: 5000,
        containerId: "Main",
      });
      setTab(2);
      setIsBlurred(false);
      setIsSubmitLoading(false);
      return;
    }

    // Prepare request payload
    const data = {
      dyhId: selectedId,
      dyhCode: selectedCode,
      dyhReferance: null,
      dyhCompany: company,
      dyhCategory: dyhCategory,
      dyhInspectionType: dyhInspectionType,
      dyhTemplate: dyhTemplate,
      dyhDescription: dyhDescription,
      dyhNextInspection: dyhNextInspection,
      dyhNextUom: dyhNextUom,
      dyhNextKm: dyhNextKm ? Number(dyhNextKm) : null,
      dyhStatus: dyhStatus,
      dyhActive: dyhActive,
      dyhReportType: dyhReportType,
      dynamicFieldRequests: fieldList?.map((field, index) => {
        // Get existing dynamicColumns from DB
        const existingColumns = field.dynamicColumns || [];

        // Get selected fields from UI (dyfMultiSelectDynamicColumn)
        const selectedColumnFields = Object.keys(
          field.dyfMultiSelectDynamicColumn || {},
        );

        // Find columns that should be created (not in existing columns)
        const newColumnsToCreate = selectedColumnFields.filter(
          (selectedField) =>
            !existingColumns.some((col) => col.ddcField == selectedField),
        );

        // Find columns that should remain (still in selection)
        const columnsToKeep = existingColumns.filter((existingColumn) =>
          selectedColumnFields.includes(existingColumn.ddcField.toString()),
        );

        return {
          dyfId: field.dyfId,
          dyfCode: field.dyfCode,
          dyfReferance: field.dyfReferance,
          dyfCompany: company,
          dyfDynamic: field.dyfDynamic,
          dyfField: field.dyfField,
          dyfFieldType: field.dyfFieldType,
          dyfUom: null,
          dfyCommonDropdown: field.dfyCommonDropdown,
          dfyCommonTable: null,
          dyfDefaultValue: field.dyfDefaultValue,
          dyfDescription: field.dyfDescription,
          dyfRequired: field.dyfRequired ? 1 : 0,
          dyfSeq: field.dyfSeq,
          dyfStatus: 2,
          dyfActive: 1,
          dfyAmount: field.dfyAmount,
          dfyDiscount: field.dfyDiscount,
          dyfCalculated: field.dyfCalculated ? 1 : 0,
          dyfComment: field.dyfComment,
          dyfSatisfyLevel: field.dyfSatisfyLevel,
          dyfFieldStatus: field.dyfFieldStatus,
          dyfTdfDescription: field.dyfTdfDescription,
          // 🚀 **Corrected DynamicColumns Payload**
          dynamicColumnRequests: [
            // ✅ Keep only existing columns that were still selected
            ...columnsToKeep.map((col) => ({
              ddcId: col.ddcId, // ✅ Keep the existing ID
              ddcReferance: col.ddcReferance || "",
              ddcCompany: company,
              ddcDyfId: field.dyfId,
              ddcField: col.ddcField,
              ddcSeq: col.ddcSeq,
              ddcStatus: col.ddcStatus,
              ddcActive: 1, // Ensure active columns stay active
              author: user.username,
            })),

            // ✅ Add new columns that were selected
            ...newColumnsToCreate.map((newField, index) => ({
              ddcId: null, // ✅ No ID, since it's new
              ddcReferance: "",
              ddcCompany: company,
              ddcDyfId: field.dyfId,
              ddcField: newField,
              ddcSeq: existingColumns.length + index + 1,
              ddcStatus: 2,
              ddcActive: 1, // Active by default
              author: user.username,
            })),
          ],

          // ✅ **Deleted columns are NOT included** (backend will detect missing ones and soft delete them)
          dynamicDropdownRequests: field.dropdownValues?.map((dropdown) => ({
            dydId: dropdown.dydId,
            dydCode: dropdown.dydCode,
            dydReferance: dropdown.dydReferance,
            dydCompany: company,
            dydDyfId: dropdown.dydDyfId,
            dydValue: dropdown.dydValue,
            dydUom: null,
            dydDescription: dropdown.dydDescription,
            dydRequired: 1,
            dydSeq: dropdown.dydSeq,
            dydStatus: 2,
            dydActive: 1,
          })),
        };
      }),

      author: user.username,
    };

    console.log("Updated Data Payload (Fixed): ", data);

    const updateData = {
      dynamicHeaderRequest: data,
      alert: alertRef.current.getData(),
      event: alertRef.current.getEvent(),
      author: user.username,
    };

    // Call API
    const response = await updateDynamicTemplate(updateData);

    if (response?.status === 200) {
      toast.success(
        `${response.data.dyhCode} template and details updated successfully!`,
        {
          autoClose: 5000,
          containerId: "Main",
        },
      );
      setEditMode(false);
      resetForm();
      handleDrawerClose();
      setUpdateNeeded(true);
    } else {
      toast.error("Failed to update the template", {
        autoClose: 5000,
        containerId: "Main",
      });
    }

    setIsSubmitLoading(false);
    setIsBlurred(false);
  };

  // Function to remove a selected column
  const handleDeleteColumn = (columnKey) => {
    setFieldData((prevData) => {
      const updatedColumns = { ...prevData.dyfMultiSelectDynamicColumn }; // ✅ Copy the object
      delete updatedColumns[columnKey]; // ✅ Remove the key

      return {
        ...prevData,
        dyfMultiSelectDynamicColumn: updatedColumns, // ✅ Ensure it's still an object
      };
    });
  };

  // Function to clear all selected columns
  const handleClearAllColumns = () => {
    setFieldData((prevData) => ({
      ...prevData,
      dyfMultiSelectDynamicColumn: {}, // ✅ Correct: Reset to empty object
    }));
  };

  console.log("AddMode", addMode);

  return (
    <>
      {isBlurred && (
        <div className="blur-overlay">
          <LoadingSpinner message={editMode ? "Updating..." : "Saving..."} />
        </div>
      )}
      <Card
        style={{
          width: "100%",
          height: "90vh",
          maxHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          overflowY: "auto",
        }}
        className={isBlurred ? "blurred" : ""}
      >
        <CardContent style={{ width: "100%" }}>
          <div className="ui tabular menu top attached">
            <Tab
              Icon={HiTemplate}
              onClick={() => {
                setTab(1);
              }}
              active={tab === 1}
              label="Template Details"
              authenticated={true}
              form={FORMS.TEMPLATE.TEM.form}
              module={MODULES.Fleet}
            />
            <Tab
              Icon={CgTemplate}
              onClick={() => {
                setTab(2);
              }}
              active={tab === 2}
              label="Template Fields"
              authenticated={true}
              form={FORMS.TEMPLATE.FIELD.form}
              module={MODULES.Fleet}
            />
            <Tab
              Icon={AlertTriangle}
              onClick={() => {
                setTab(3);
              }}
              active={tab === 3}
              label="Alert"
              authenticated={true}
              form={FORMS.TEMPLATE.FIELD_ALERT.form}
              module={MODULES.Fleet}
            />
          </div>
          <div
            className="ui bottom attached active segment"
            style={{ display: tab === 1 ? "block" : "none", width: "100%" }}
          >
            {isLoading || isEditModeDataLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <h4 className="ui dividing header">Template General Details</h4>
                <div className="three fields">
                  <Dropdown
                    required={true}
                    clearable
                    search={true}
                    options={categoryOptions}
                    placeholder="Select Category"
                    label="Category"
                    value={dyhCategory}
                    onChange={(e, data) => {
                      setDyhCategory(data.value);
                    }}
                    error={currentErrors.dyhCategory}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { dyhCategory: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Dropdown
                    required={true}
                    clearable
                    search={true}
                    options={managementTypeOptions}
                    placeholder={"Select Management Type"}
                    label="Management Type"
                    value={dyhInspectionType}
                    onChange={(e, data) => {
                      setDyhInspectionType(data.value);
                    }}
                    error={currentErrors.dyhInspectionType}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { dyhInspectionType: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Input
                    required={true}
                    label="Template Name"
                    type="text"
                    name="templateName"
                    blockPattern={/[#%]/g}
                    value={dyhTemplate}
                    onChange={(e) => setDyhTemplate(e.target.value)}
                    error={currentErrors.dyhTemplate}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { dyhTemplate: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                </div>
                <div className="three fields">
                  <Input
                    required={true}
                    label="Next Inspection Value"
                    type="number"
                    name="nextInspectionValue"
                    value={dyhNextInspection}
                    onChange={(e) => {
                      setDyhNextInspection(e.target.value);
                    }}
                    error={currentErrors.dyhNextInspection}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { dyhNextInspection: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />

                  <div className="four wide field">
                    <Dropdown
                      clearable
                      search={true}
                      required={true}
                      options={uomOptions}
                      placeholder="UOM"
                      label="UOM"
                      value={dyhNextUom}
                      onChange={(e, data) => {
                        setDyhNextUom(data.value);
                      }}
                      error={currentErrors.dyhNextUom}
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { dyhNextUom: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                    />
                  </div>
                  <Input
                    required={false}
                    label="Next Km (in Km)"
                    type="number"
                    name="nextKm"
                    value={dyhNextKm}
                    onChange={(e) => {
                      setDyhNextKm(e.target.value);
                    }}
                    error={currentErrors.dyhNextKm}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { dyhNextkm: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Input
                    label="Description"
                    type="text"
                    name="description"
                    value={dyhDescription}
                    blockPattern={/[#%]/g}
                    onChange={(e) => {
                      setDyhDescription(e.target.value);
                    }}
                    error={currentErrors.dyhDescription}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { dyhDescription: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                </div>
                <div className="two fields">
                  <Dropdown
                    label="Status"
                    name="status"
                    clearable
                    required={true}
                    placeholder="Select Status"
                    options={statusOptions}
                    value={dyhStatus}
                    onChange={(e, data) => setDyhStatus(data.value)}
                    error={currentErrors.dyhStatus}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { dyhStatus: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                  <Dropdown
                    label="Active"
                    name="active"
                    clearable
                    required={true}
                    placeholder="Select Active"
                    options={activeOptions}
                    editMode={editMode}
                    authenticated={true}
                    form={FORMS.TEMPLATE.TEM.form}
                    module={MODULES.Fleet}
                    field="dyh_active"
                    value={dyhActive}
                    onChange={(e, data) => setDyhActive(data.value)}
                    error={currentErrors.dyhActive}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { dyhActive: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                </div>
                <div className="two fields">
                  <Dropdown
                    required={true}
                    clearable
                    search={true}
                    options={dynamicReportTypeOptions}
                    placeholder="Select Report Type"
                    label="Report Type"
                    value={dyhReportType}
                    onChange={(e, data) => {
                      setDyhReportType(data.value);
                    }}
                    error={currentErrors.dyhReportType}
                    resetError={() =>
                      setCurrentErrors((prevState) => {
                        const { dyhReportType: _, ...rest } = prevState;
                        return rest;
                      })
                    }
                  />
                </div>
              </form>
            )}
          </div>

          <div
            className="ui bottom attached active segment"
            style={{ display: tab === 2 ? "block" : "none", width: "100%" }}
          >
            {isLoading || isEditModeDataLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <div className="ui segment">
                  <h4 className="ui dividing header">
                    {"Add Fields to " + dyhTemplate ? dyhTemplate : "Template"}
                  </h4>
                  <div className="three fields">
                    <Input
                      required={true}
                      label="Field Name"
                      type="text"
                      name="fieldName"
                      value={fieldData.dyfField}
                      blockPattern={/[#%]/g}
                      onChange={(e) => {
                        setFieldData({
                          ...fieldData,
                          dyfField: e.target.value,
                        });
                      }}
                      error={currentErrors.dyfField}
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { dyfField: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                    />
                    <Input
                      required={false}
                      label="Reference"
                      type="text"
                      name="reference"
                      value={fieldData.dyfReferance}
                      blockPattern={/[#%]/g}
                      onChange={(e) => {
                        setFieldData({
                          ...fieldData,
                          dyfReferance: e.target.value,
                        });
                      }}
                      error={currentErrors.dyfReferance}
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { dyfReferance: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                    />
                    <Dropdown
                      clearable
                      required={true}
                      search={true}
                      options={fieldTypeOptions}
                      placeholder="Field Type"
                      label="Field Type"
                      value={fieldData.dyfFieldType}
                      onChange={(e, data) => {
                        setFieldData({
                          ...fieldData,
                          dyfFieldType: data.value,
                        });
                        console.log(data.value);
                      }}
                      error={currentErrors.dyfFieldType}
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { dyfFieldType: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                      disabled={!addMode}
                    />
                  </div>
                  <div className="five fields">
                    {fieldData.dyfFieldType === 3 && (
                      <Input
                        label="Default Value"
                        type="text"
                        name="defaultValue"
                        blockPattern={/[#%]/g}
                        value={fieldData.dyfDefaultValue}
                        onChange={(e) => {
                          setFieldData({
                            ...fieldData,
                            dyfDefaultValue: e.target.value,
                          });
                        }}
                      />
                    )}
                    {fieldData.dyfFieldType === 5 && (
                      <Input
                        label="Default Value"
                        type="date"
                        name="defaultValue"
                        value={fieldData.dyfDefaultValue}
                        onChange={(e) => {
                          setFieldData({
                            ...fieldData,
                            dyfDefaultValue: e.target.value,
                          });
                        }}
                      />
                    )}
                    {fieldData.dyfFieldType === 6 && (
                      <CheckBox
                        label="Default Value"
                        name="defaultValue"
                        checked={fieldData.dyfDefaultValue}
                        onChange={(e) => {
                          setFieldData({
                            ...fieldData,
                            dyfDefaultValue: !fieldData.dyfDefaultValue,
                          });
                        }}
                      />
                    )}
                    {fieldData.dyfFieldType === 7 && (
                      <Input
                        label="Default Value"
                        type="number"
                        name="defaultValue"
                        value={fieldData.dyfDefaultValue}
                        onChange={(e) => {
                          setFieldData({
                            ...fieldData,
                            dyfDefaultValue: e.target.value,
                          });
                        }}
                      />
                    )}

                    {fieldData.dyfFieldType === 8 && (
                      <Dropdown
                        required={fieldData.dyfFieldType === 8}
                        clearable={false}
                        search={true}
                        label={"Common Dropdown"}
                        placeholder={
                          isDynamicDropdownValuesLoading ? "Loading.." : ""
                        }
                        options={commonDropdownOptions}
                        value={commonDropdownInput}
                        onChange={(e, data) => {
                          console.log("The data: ", data.value);
                          try {
                            const parsedData = JSON.parse(data.value);
                            setCommonDropdownInput(data.value);
                            setCommonDropdownId(parsedData);
                            setFieldData({
                              ...fieldData,
                              dfyCommonDropdown: parsedData.dcmId,
                              dfyCommonDropdownValue: parsedData.dcmName,
                            });
                          } catch (error) {
                            console.error(
                              "Error parsing commonDropdownInput:",
                              error,
                            );
                            setCommonDropdownInput({});
                          }
                        }}
                        disabled={isDynamicDropdownValuesLoading}
                        error={currentErrors.dfyCommonDropdown}
                        resetError={() =>
                          setCurrentErrors((prevState) => {
                            const { dfyCommonDropdown: _, ...rest } = prevState;
                            return rest;
                          })
                        }
                      />
                    )}

                    <Input
                      label="Description"
                      type="text"
                      name="fieldDescription"
                      value={fieldData.dyfDescription}
                      blockPattern={/[#%]/g}
                      onChange={(e) => {
                        setFieldData({
                          ...fieldData,
                          dyfDescription: e.target.value,
                        });
                      }}
                    />

                    <Input
                      type="checkbox"
                      label="Is Mandatory ?"
                      name="isMandatory"
                      checked={fieldData.dyfRequired}
                      onChange={(e) => {
                        setFieldData({
                          ...fieldData,
                          dyfRequired: e.target.checked,
                        });
                      }}
                    />
                    <Dropdown
                      label="Amount"
                      placeholder="Yes/No"
                      clearable={false}
                      options={yesNoOptions}
                      value={fieldData.dfyAmount}
                      onChange={(e, data) => {
                        setFieldData({
                          ...fieldData,
                          dfyAmount: data.value,
                          dfyDiscount: data.value === 2 ? 2 : prev.dfyDiscount,
                        });
                      }}
                      error={currentErrors.dfyAmount}
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { dfyAmount: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                    />
                    <Dropdown
                      label="Discount"
                      placeholder="Yes/No"
                      clearable={false}
                      options={yesNoOptions}
                      value={fieldData.dfyDiscount}
                      onChange={(e, data) => {
                        setFieldData({ ...fieldData, dfyDiscount: data.value });
                      }}
                      error={currentErrors.dfyDiscount}
                      resetError={() =>
                        setCurrentErrors((prevState) => {
                          const { dfyDiscount: _, ...rest } = prevState;
                          return rest;
                        })
                      }
                      disabled={fieldData.dfyAmount === 2}
                    />
                  </div>
                  <div className="three fields">
                    <Input
                      label="Comment"
                      type="text"
                      name="comment"
                      blockPattern={/[#%]/g}
                      value={fieldData.dyfComment}
                      onChange={(e) => {
                        setFieldData({
                          ...fieldData,
                          dyfComment: e.target.value,
                        });
                      }}
                    />
                    <Input
                      type="checkbox"
                      label="Show Satisfy Level(SL)?"
                      name="showSatisfyLevel"
                      checked={fieldData.dyfSatisfyLevel}
                      onChange={(e) => {
                        setFieldData({
                          ...fieldData,
                          dyfSatisfyLevel: e.target.checked,
                        });
                      }}
                    />
                    <Input
                      type="checkbox"
                      label="Show Field Status(FS)?"
                      name="showFieldStatus"
                      checked={fieldData.dyfFieldStatus}
                      onChange={(e) => {
                        setFieldData({
                          ...fieldData,
                          dyfFieldStatus: e.target.checked,
                        });
                      }}
                    />
                    <Input
                      type="checkbox"
                      label="Show Description(DES)?"
                      name="showDescription"
                      checked={fieldData.dyfTdfDescription}
                      onChange={(e) => {
                        setFieldData({
                          ...fieldData,
                          dyfTdfDescription: e.target.checked,
                        });
                      }}
                    />
                  </div>
                  {fieldData.dyfFieldType === 7 ||
                  fieldData.dyfFieldType === 4 ? (
                    <div className="four fields">
                      <Input
                        type="checkbox"
                        label="Is Calculated(Cal)?"
                        name="isCalculated"
                        checked={fieldData.dyfCalculated}
                        onChange={(e) => {
                          setFieldData({
                            ...fieldData,
                            dyfCalculated: e.target.checked,
                          });
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="ui segment">
                  <h4 className="ui dividing header">Map Columns</h4>

                  {/* Multi-select dropdown for columns */}
                  <div
                    className="ui form field"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <div className="wide fourteen field">
                      <Dropdown
                        label={"Map Columns"}
                        options={dyhMultiSelectDynamicColumnOptions.filter(
                          (option) =>
                            !(
                              fieldData.dyfMultiSelectDynamicColumn &&
                              fieldData.dyfMultiSelectDynamicColumn[
                                option.value
                              ]
                            ),
                        )}
                        value={null} // Keeps dropdown empty after selection
                        onChange={(e, data) => {
                          const selectedColumn =
                            dyhMultiSelectDynamicColumnOptions.find(
                              (option) => option.value === data.value,
                            );
                          if (selectedColumn) {
                            setFieldData((prevData) => ({
                              ...prevData,
                              dyfMultiSelectDynamicColumn: {
                                ...(prevData.dyfMultiSelectDynamicColumn || {}), // ✅ Ensure it is an object
                                [selectedColumn.value]: selectedColumn.text, // ✅ Store as { key: value }
                              },
                            }));
                          }
                        }}
                        clearable={true}
                        multiple={false} // Single selection at a time
                        search={true}
                      />
                    </div>

                    {/* Clear All Button */}
                    <div className="one wide field">
                      <Button
                        label="Clear All"
                        onClick={handleClearAllColumns}
                        style={{
                          backgroundColor: "red",
                          color: "white",
                          padding: "8px 12px",
                          marginTop: "5px",
                          borderRadius: "5px",
                          cursor: "pointer",
                          height: "35px",
                        }}
                      />
                    </div>
                  </div>

                  {/* Display Selected Columns as Labels */}
                  <div
                    className="ui padded segment"
                    style={{ width: "100%", height: "100px", overflow: "auto" }}
                  >
                    {Object.keys(fieldData.dyfMultiSelectDynamicColumn || {})
                      .length === 0 ? (
                      <div
                        className="ui grey header"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        No Columns Mapped
                      </div>
                    ) : (
                      <>
                        {Object.entries(
                          fieldData.dyfMultiSelectDynamicColumn,
                        ).map(([key, name]) => (
                          <Label
                            as="a"
                            style={{ marginBottom: "10px" }}
                            key={key}
                          >
                            {name} {/* ✅ Display stored name */}
                            <Icon
                              name="delete"
                              onClick={() => handleDeleteColumn(key)}
                              style={{ cursor: "pointer", marginLeft: "5px" }}
                            />
                          </Label>
                        ))}
                      </>
                    )}
                  </div>
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div
                    className="two fields"
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      template="addOrSave"
                      label={
                        !addMode
                          ? fieldData.dyfFieldType === 4
                            ? "Update dropdown values"
                            : "Update"
                          : fieldData.dyfFieldType === 4
                            ? "Add dropdown values"
                            : "Add"
                      }
                      authenticated={true}
                      editMode={editMode}
                      module={MODULES.Fleet}
                      form={FORMS.TEMPLATE.FIELD.form}
                      Icon={!addMode ? Edit : Plus}
                      create={addMode}
                      style={{ height: "40px" }} //, marginTop: '20px'
                      onClick={onFieldAddClick}
                      isLoading={fieldAddLoading}
                    />

                    {fieldData.dyfFieldType === 4 && !addMode && (
                      <Button
                        label={"Update field"}
                        Icon={Edit}
                        onClick={editDropdownFieldWithoutValues}
                        isLoading={fieldAddLoading}
                      />
                    )}
                  </div>
                </div>
                <Grid
                  searchable={false}
                  ref={gridFieldRef}
                  heading="Field List"
                  isLoading={isEditModeDataLoading}
                  config={[
                    {
                      headerName: "Field Name",
                      field: "dyfField",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Referance",
                      field: "dyfReferance",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Field Type",
                      field: "dyfFieldType",
                      cellRenderer: AsyncDropdownValueRenderer,
                      cellRendererParams: { dropdownKey: "component_type" },
                    },
                    {
                      headerName: "Dropdown Values",
                      field: "dropdownValues",
                      cellRendererSelector: (params) => {
                        if (params.data.dyfFieldType === 4) {
                          return {
                            component: SelectRenderer,
                            params: {
                              options: params.data.dropdownValues?.map(
                                (item) => ({
                                  key: item.id,
                                  value: item.id,
                                  text: item.dydValue,
                                }),
                              ),
                            },
                          };
                        } else if (params.data.dyfFieldType === 8) {
                          return {
                            component: () => params.data.dfyCommonDropdownValue,
                          };
                        } else {
                          return {
                            component: () => "N/A",
                          };
                        }
                      },
                      cellRendererParams: (params) => {
                        return {
                          options: params.data.dropdownValues?.map((item) => ({
                            key: item.id,
                            value: item.id,
                            text: item.dydValue,
                          })),
                        };
                      },
                    },
                    {
                      headerName: "Default Value",
                      valueGetter: (params) => {
                        if (params.data.dyfFieldType === 4) {
                          return params.data.dropdownDefaultValueName;
                        } else {
                          return params.data.dyfDefaultValue;
                        }
                      },
                    },
                    {
                      headerName: "M",
                      field: "dyfRequired",
                      width: 50,
                      minWidth: 50,
                    },
                    {
                      headerName: "A",
                      field: "dfyAmount",
                      cellRenderer: AsyncDropdownValueRenderer,
                      cellRendererParams: { dropdownKey: "yesno" },
                      width: 60,
                      minWidth: 60,
                    },
                    {
                      headerName: "D",
                      field: "dfyDiscount",
                      cellRenderer: AsyncDropdownValueRenderer,
                      cellRendererParams: { dropdownKey: "yesno" },
                      width: 60,
                      minWidth: 60,
                    },
                    {
                      headerName: "Description",
                      field: "dyfDescription",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Comment",
                      field: "dyfComment",
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "DES",
                      field: "dyfTdfDescription",
                      width: 60,
                      minWidth: 60,
                    },
                    {
                      headerName: "SL",
                      field: "dyfSatisfyLevel",
                      width: 50,
                      minWidth: 50,
                    },
                    {
                      headerName: "FS",
                      field: "dyfFieldStatus",
                      width: 50,
                      minWidth: 50,
                    },
                    {
                      headerName: "Cal",
                      field: "dyfCalculated",
                      width: 50,
                      minWidth: 50,
                    },
                    {
                      field: "Edit",
                      cellRenderer: ButtonRenderer,
                      cellRendererParams: (params) => ({
                        consider: AUTH_TYPES.CREATE,
                        clickHandler: async () => {
                          setCurrentErrors({});

                          setCommonDropdownInput(
                            JSON.stringify({
                              dcmId: params.data.dfyCommonDropdown,
                              dcmName: params.data.dfyCommonDropdownValue,
                            }),
                          );

                          setEditIndex(params.node.rowIndex);

                          let selectedColumns =
                            params.data.dyfMultiSelectDynamicColumn || {};

                          // Ensure correct mapping
                          selectedColumns = Object.entries(
                            selectedColumns,
                          ).reduce((acc, [key, name]) => {
                            acc[key] = name || "Unknown Column";
                            return acc;
                          }, {});

                          setFieldData({
                            ...params.data,
                            dyfMultiSelectDynamicColumn: selectedColumns,
                          });

                          setAddMode(false);

                          if (!params.data.dyfId) {
                            setFlag(true);
                          }
                        },

                        label: "Edit",
                        className: "ui secondary button",
                        authenticated: true,
                        form: FORMS.TEMPLATE.FIELD.form,
                        module: MODULES.Fleet,
                        editMode: editMode,
                      }),
                      width: 110,
                      minWidth: 110,
                    },
                    {
                      field: "Delete",
                      cellRenderer: ButtonRenderer,
                      cellRendererParams: (params) => ({
                        consider: AUTH_TYPES.DELETE,
                        clickHandler: () => {
                          // Prevent deletion if this row is being edited
                          if (editIndex === params.node.rowIndex) {
                            toast.error(
                              "You cannot delete this field while it is being edited.",
                              {
                                autoClose: 5000,
                                containerId: "Main",
                              },
                            );
                            return;
                          }

                          dispatch(templateActions.deleteField(params.data));
                          setFieldSeq((prevSeq) => prevSeq - 1);
                          // setProceedReset(true);
                        },
                        label: "Delete",
                        className: "ui red button",
                        authenticated: true,
                        form: FORMS.TEMPLATE.FIELD.form,
                        module: MODULES.Fleet,
                        editMode:
                          params.data.dyfId !== null &&
                          isNumber(params.data.dyfId),
                      }),
                      width: 120,
                      minWidth: 120,
                    },
                  ]}
                  content={fieldList}
                />
              </form>
            )}
          </div>
          <div
            className="ui bottom attached active segment"
            style={{ display: tab === 3 ? "block" : "none", width: "100%" }}
          >
            <AlertForm
              opeType={16}
              ref={alertRef}
              errors={true}
              dropdown={{
                altActiveOpt,
                altStatusOpt,
                altTypeOpt,
                altEventOpt,
                altDefaultTypeOpt,
              }}
              isLoading={isLoading}
              editMode={editMode}
              module={MODULES.Fleet}
              currentValues={editMode ? dyhAlert.alert : null}
            />
          </div>

          <Modal
            ref={modalRef}
            onCloseCleanUp={() => {
              setDropdownValue({
                id: null,
                dydId: null,
                dydReferance: "",
                dydCompany: 1,
                dydDyfId: null,
                dydValue: "",
                dydUom: null,
                dydDescription: "",
                dydRequired: false,
                dydSeq: 1,
                dydStatus: 2,
                dydActive: 1,
                default: false,
                author: user.username,
              });

              setFieldData((prev) => ({
                ...prev,
                dropdownValues: [
                  ...prev.dropdownValues?.filter((item) => item.dydId !== null),
                ],
              }));

              setFieldData((prevData) => ({
                ...prevData,
                currentDropdownSeq: prevData.dropdownValues?.length + 1,
              }));
            }}
          >
            <TemplateDropdown
              fieldData={fieldData}
              setFieldData={setFieldData}
              closeModal={closeModal}
              setProceedReset={setProceedReset}
              flag={flag}
              setFlag={setFlag}
              editMode={editMode}
              isEditModeDataLoading={isEditModeDataLoading}
              addModeInModal={addModeInModal}
              setAddModeInModal={setAddModeInModal}
              fieldSeq={fieldSeq}
              setFieldSeq={setFieldSeq}
              dropdownValue={dropdownValue}
              setDropdownValue={setDropdownValue}
              setAddMode={setAddMode}
            />
          </Modal>
        </CardContent>
        {editMode && (
          <InfoList
            title="User Information"
            content={[
              {
                title: "Created By",
                value: auditInfo.createdBy ? auditInfo.createdBy : "N/A",
              },
              {
                title: "Created Date",
                value: auditInfo.createdDate
                  ? formatFromJsonDate(auditInfo.createdDate)
                  : "N/A",
              },
              {
                title: "Last Modified By",
                value: auditInfo.lastModifiedBy
                  ? auditInfo.lastModifiedBy
                  : "N/A",
              },
              {
                title: "Last Modified Date",
                value: auditInfo.lastModifiedDate
                  ? formatFromJsonDate(auditInfo.lastModifiedDate)
                  : "N/A",
              },
            ]}
            Icon={User}
          />
        )}
        {!(editMode && isEditModeDataLoading) && !fieldAddLoading ? (
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              padding: "1rem",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              {tab > firstViableTab && tab < 3 && (
                <Button
                  template="back"
                  tab={tab - 1}
                  module={MODULES.Fleet}
                  section={FORMS.TEMPLATE}
                  authenticated={true}
                  onClick={() => setTab(prev())}
                />
              )}
              {tab < lastViableTab && (
                <Button
                  template="next"
                  tab={tab + 1}
                  module={MODULES.Fleet}
                  section={FORMS.TEMPLATE}
                  authenticated={true}
                  onClick={nextButtonHandler}
                />
              )}

              {editMode ? (
                <Button
                  type="submit"
                  template="create"
                  isLoading={isSubmitLoading}
                  create={!editMode}
                  editMode={editMode}
                  onClick={updateTemplate}
                  form={FORMS.TEMPLATE.DYNAMIC_TEM.form}
                  module={MODULES.Fleet}
                  authenticated={true}
                />
              ) : tab === lastViableTab ? (
                <Button
                  type="submit"
                  template="create"
                  isLoading={isSubmitLoading}
                  create={!editMode}
                  editMode={editMode}
                  onClick={saveTemplate}
                  form={FORMS.TEMPLATE.DYNAMIC_TEM.form}
                  module={MODULES.Fleet}
                  authenticated={true}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          ""
        )}
      </Card>
    </>
  );
};
export default DynamicTemplateCreation;

const styles = `
  .blur-overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    z-index: 9999; /* Ensure it's on top of everything */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .blurred {
    filter: blur(5px); /* Blur effect on content */
    pointer-events: none; /* Prevent interaction with blurred content */
  }
`;

document.head.insertAdjacentHTML("beforeend", `<style>${styles}</style>`);
